import React, { Component } from 'react'

import s from '../Checkbox/Checkbox.scss'
import cn from 'classnames'
import sLay from 'styles/modules/layout.scss'
import sText from 'components/Text/Text.scss'

export default class Radio extends Component {
  onChange = event => {
    const { input, radioValue, onChangeAlt, afterChange } = this.props
    if (onChangeAlt) {
      onChangeAlt(event)
    } else {
      input.onChange(radioValue)
    }
    if (afterChange) {
      afterChange(radioValue)
    }
  }
  render() {
    const {
      className,
      style,
      label,
      showTip,
      radioValue,
      input,
      meta: { touched, error },
      disabled,
    } = this.props
    const id = Math.random()
      .toString(36)
      .substring(7)
    const isInvalid = touched && error
    const classes = cn(
      s.checkbox,
      { [s.active]: input.value == radioValue },
      { [s.invalid]: isInvalid },
      { [s.disabled]: disabled },
      sLay['layout-row'],
      sLay['layout-align-start-center'],
      className
    )

    return (
      <div>
        <div className={classes} style={style}>
          <label htmlFor={id} />
          <input
            id={id}
            value={radioValue}
            checked={input.value == radioValue}
            type="radio"
            {...input}
            onChange={this.onChange}
            onBlur={() => {}}
          />
          {label && (
            <div className={sText.descrip2} style={{ marginLeft: '10px' }}>
              {label}
            </div>
          )}
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/components/Input/Radio/Radio.jsx